import PaymentMethod from "features/payment-methods/components/PaymentMethod";
import useSubscriptionPaymentSourceMutations from "features/payment-methods/datahooks/useSubscriptionPaymentSourceMutations";
import type { PaymentSource } from "features/payment-methods/types";

//this component automatically sets the subscription payment method on the server, based on the provided ID
export default function SubscriptionPaymentMethod({
  subscriptionId,
  onBack,
  onSuccess,
  initialPaymentSource,
}: {
  subscriptionId: string;
  onBack: () => void;
  onSuccess: () => void;
  initialPaymentSource?: PaymentSource;
}) {
  const { setPaymentSource, isSettingPaymentSource, setPaymentSourceError } =
    useSubscriptionPaymentSourceMutations();

  function onSetPaymentSource(paymentSource: PaymentSource) {
    setPaymentSource({ subscriptionId, paymentSource }).then(onSuccess);
  }

  return (
    <PaymentMethod
      initialPaymentSource={initialPaymentSource}
      onBack={onBack}
      setPaymentSource={onSetPaymentSource}
      isSettingPaymentSource={isSettingPaymentSource}
      setPaymentSourceError={setPaymentSourceError}
    />
  );
}
